// Transient feedback toast. Shows when `host.toastMessage` is set —
// driven by `flashToast` in functions/index.js. Auto-dismisses after
// 4s via the same helper. When `host.toastUndoItemId` is non-null,
// an Undo button renders alongside the message (reverses the install
// via `undoInstall`). Hidden when no toast active.
//
// Absolute-positioned relative to the Island so it floats above the
// grid + detail pane. `pointer-events: none` on the outer shell +
// restored on the inner wrapper so invisible toasts don't block
// clicks on the grid behind them.

export const MarketplaceToast = {
  hide: (el) => {
    const host = el.call('marketplaceHostOf', el)
    return !host?.toastMessage
  },
  position: 'absolute',
  bottom: 'A',
  right: 'A',
  flow: 'x',
  gap: 'Z',
  align: 'center',
  padding: 'Z A',
  borderRadius: 'Z',
  border: '1px solid line',
  background: 'dialog',
  // DS-token boxShadow — see design-system/pages/transitions.js and
  // canvas/components/DesignSystemPanel.js for the same pattern:
  // `0 <offsetY> <blur> <color>` where offsets/blur use spacing tokens
  // and color uses a DS alpha modifier.
  boxShadow: '0 Z A black.2',
  zIndex: '10',

  ToastText: {
    tag: 'span',
    text: (el) => {
      const host = el.call('marketplaceHostOf', el)
      return host?.toastMessage || ''
    },
    fontSize: 'Y',
    color: 'title',
    fontWeight: '500'
  },

  ToastUndoBtn: {
    extends: 'Button',
    hide: (el) => {
      const host = el.call('marketplaceHostOf', el)
      return !host?.toastUndoItemId
    },
    text: 'Undo',
    fontSize: 'Y',
    padding: 'X Z',
    background: 'transparent',
    color: 'blue',
    fontWeight: '600',
    onClick: (e, el) => {
      const host = el.call('marketplaceHostOf', el)
      el.call('undoInstall', host, host?.toastUndoItemId)
    }
  }
}
